// extracted by mini-css-extract-plugin
export default {"Wrapper":"ListPage_Wrapper__7NSuZ","CardList":"ListPage_CardList__E62iG","LinkDiv":"ListPage_LinkDiv__6+Ab1"};